exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info[data-v-2a5bfa54]{position:absolute;top:30px;left:10%}.info button[data-v-2a5bfa54]{padding:10px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-2a5bfa54","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{}!./~/vue-loader/lib/selector.js?type=styles&index=0!./demos/pages/demo-pano.vue
// module id = 132
// module chunks = 1